const zone = 'America/New_York'
export const dateKey = value => new Intl.DateTimeFormat('en-CA', { timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(value))
export const addDays = (key, days) => new Date(Date.parse(`${key}T12:00:00Z`) + days * 86400000).toISOString().slice(0, 10)
export function midnight(key) {
  const target = Date.parse(`${key}T00:00:00Z`)
  let value = target
  for (let i = 0; i < 3; i++) {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-US', { timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }).formatToParts(new Date(value)).map(p => [p.type, p.value]))
    value += target - Date.parse(`${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}Z`)
  }
  return value
}
export function weekStart(key, firstDay = 1) {
  const weekday = new Date(`${key}T12:00:00Z`).getUTCDay()
  return addDays(key, -((weekday - firstDay + 7) % 7))
}
export function workedInRange(entry, start, end, now) {
  const from = Math.max(Date.parse(entry.clockInAt), start)
  const to = Math.min(entry.clockOutAt ? Date.parse(entry.clockOutAt) : now, end, now)
  if (!Number.isFinite(from) || !Number.isFinite(to) || to <= from) return { workedMs: 0, breakMs: 0, open: false }
  const intervals = (entry.breaks || []).map(p => [Math.max(from, Date.parse(p.startedAt)), Math.min(to, p.endedAt ? Date.parse(p.endedAt) : to)])
    .filter(([a, b]) => Number.isFinite(a) && Number.isFinite(b) && b > a).sort((a, b) => a[0] - b[0])
  let pause = 0, last = from
  for (const [a, b] of intervals) { pause += Math.max(0, b - Math.max(a, last)); last = Math.max(last, b) }
  return { workedMs: to - from - pause, breakMs: pause, open: !entry.clockOutAt }
}
export function weeklySummary(entries, startKey, now, roster = []) {
  const days = Array.from({ length: 7 }, (_, i) => addDays(startKey, i))
  const start = midnight(startKey), end = midnight(addDays(startKey, 7))
  const people = new Map(roster.map(p => [p.operatorId, { ...p, workedMs: 0, breakMs: 0, open: false, daily: days.map(() => 0) }]))
  for (const entry of entries) {
    const result = workedInRange(entry, start, end, now)
    if (!result.workedMs && !result.breakMs && !people.has(entry.operatorId)) continue
    const person = people.get(entry.operatorId) || { operatorId: entry.operatorId, name: entry.operatorName, workedMs: 0, breakMs: 0, open: false, daily: days.map(() => 0) }
    person.workedMs += result.workedMs; person.breakMs += result.breakMs; person.open ||= result.open
    person.daily = person.daily.map((value, i) => value + workedInRange(entry, midnight(days[i]), midnight(addDays(days[i], 1)), now).workedMs)
    people.set(entry.operatorId, person)
  }
  return { start, end, days, people: [...people.values()].sort((a, b) => a.name.localeCompare(b.name)) }
}
export const hoursText = ms => `${Math.floor(ms / 3600000)}h ${String(Math.floor(ms / 60000) % 60).padStart(2, '0')}m`
export function estimatePay(ms, rate) {
  if (!/^(?:0|[1-9]\d{0,5})(?:[.,]\d{1,2})?$/.test(rate.trim())) return null
  const cents = Math.round(Number(rate.replace(',', '.')) * 100)
  return Math.round(ms * cents / 3600000) / 100
}
